import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes';
import { useAuthStore } from '@/stores/useAuthStore';

export const queryClient = new QueryClient({
  defaultOptions: {
    // Disconnected submissions fail immediately; never queue a write for reconnect.
    mutations: { networkMode: 'always', retry: false },
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

useAuthStore.subscribe((state, previous) => {
  if (
    state.sessionEpoch !== previous.sessionEpoch ||
    state.member?.id !== previous.member?.id
  )
    queryClient.clear();
});

export default function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        {import.meta.env.DEV && (
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          />
        )}
      </QueryClientProvider>
    </>
  );
}
